import { useAuth } from '@skyslope/auth-react';
import { useQuery } from '@tanstack/react-query';
import type { QueryOptionsType } from '@/lib/api/envelope/query-helpers';
import { getGlobalToken } from '../../auth/oktaConfig';
import { integrationsApiUrl } from '../../lib/environment-config';
import type { IntegrationsResponse } from './types';

export const getIntegrationsQueryKey = 'get-integrations';

export function useGetIntegrations(options: QueryOptionsType<typeof getIntegrations>) {
  const { userContext } = useAuth();

  return useQuery<IntegrationsResponse>({
    queryKey: [getIntegrationsQueryKey, userContext?.id],
    queryFn: () => {
      if (!userContext?.id) throw new Error('User ID is required');
      return getIntegrations(userContext.id);
    },
    ...options,
    enabled: options?.enabled && !!userContext?.id,
  });
}

export async function getIntegrations(userId: string): Promise<IntegrationsResponse> {
  const accessToken = await getGlobalToken();

  const result = await fetch(`${integrationsApiUrl}/users/${userId}/integrations`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return result.json();
}
